import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Utility function to merge Tailwind CSS classes with proper precedence
 * This is the standard cn() utility used by shadcn/ui
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
